import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Rsvp } from "../../interfaces/Rsvp.interface";
import { StartingPoint } from "../../interfaces/StartingPoint.interface";
import { getStartingPoint } from "../../utilities/helpers/getStartingPointName";

interface RsvpTableProps {
  rsvps: Rsvp[];
  startingPoints?: StartingPoint[];
}

export const RsvpTable = ({ rsvps, startingPoints }: RsvpTableProps) => {
  return (
    <TableContainer>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            {startingPoints && (
              <TableCell align="right">Starting Point</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rsvps.map((rsvp) => (
            <TableRow
              key={rsvp.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {rsvp.name}
              </TableCell>
              {startingPoints && (
                <TableCell align="right">
                  {getStartingPointName(startingPoints, rsvp.starting_point_id)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const getStartingPointName = (
  startingPoints: StartingPoint[],
  id: string | null
): string => {
  const startingPoint = getStartingPoint(startingPoints, id);

  return startingPoint ? startingPoint.name : "";
};
